import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15b13587"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "find-users container" }
const _hoisted_2 = { class: "text-start fw-bold pt-5 pb-3" }
const _hoisted_3 = { class: "search input-group flex-column flex-sm-row rounded-pill mb-5" }
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  class: "btn btn-outline-secondary dropdown-toggle mb-2 mb-sm-0",
  type: "toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false",
  id: "searchBy"
}
const _hoisted_6 = {
  class: "dropdown-menu dropdown-menu-end",
  id: "searchByDropdown"
}
const _hoisted_7 = ["value", "onClick"]
const _hoisted_8 = {
  class: "btn btn-outline-secondary dropdown-toggle rounded-end-5",
  type: "toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false",
  id: "sortBy"
}
const _hoisted_9 = {
  class: "dropdown-menu dropdown-menu-end",
  id: "sortByDropdown"
}
const _hoisted_10 = ["value", "onClick"]
const _hoisted_11 = {
  key: 0,
  id: "users"
}
const _hoisted_12 = {
  key: 1,
  class: "m-5"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-center text-black-50" }, "No users found.", -1))
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FindComponent = _resolveComponent("FindComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, " Find " + _toDisplayString(_ctx.role === "Donor" ? "Charities" : "Donors"), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("input", {
        type: "text",
        class: "form-control form-control-lg border-primary rounded-start-5 fs-6 mb-2 mb-sm-0 p-sm-3",
        "aria-label": "Search by",
        placeholder: "Search here...",
        id: "searchBar",
        value: _ctx.searchText,
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setSearchText($event.target.value)))
      }, null, 40, _hoisted_4),
      _createElementVNode("button", _hoisted_5, " Search by: " + _toDisplayString(_ctx.searchBy), 1),
      _createElementVNode("ul", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchByOptions, (option) => {
          return (_openBlock(), _createElementBlock("li", { key: option }, [
            _createElementVNode("button", {
              class: "dropdown-item",
              value: option,
              onClick: ($event: any) => (_ctx.setSearchBy(option))
            }, _toDisplayString(option), 9, _hoisted_7)
          ]))
        }), 128))
      ]),
      _createElementVNode("button", _hoisted_8, " Sort by: " + _toDisplayString(_ctx.sortBy), 1),
      _createElementVNode("ul", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortByOptions, (option) => {
          return (_openBlock(), _createElementBlock("li", { key: option }, [
            _createElementVNode("button", {
              class: "dropdown-item",
              value: option,
              onClick: ($event: any) => (_ctx.setSortBy(option))
            }, _toDisplayString(option), 9, _hoisted_10)
          ]))
        }), 128))
      ])
    ]),
    (_ctx.filteredUsers.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredUsers, (user) => {
            return (_openBlock(), _createBlock(_component_FindComponent, {
              key: user.id,
              user: user
            }, null, 8, ["user"]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
  ]))
}